'use client'

import React from 'react'

import { ContentModelHrType } from '@/types/ContentModel/ContentModelHr'

export default function Hr({ contentModel }: { contentModel: ContentModelHrType }) {
  return <hr style={{ ...(contentModel.borderColor != null ? { borderColor: contentModel.borderColor } : {}) }} />
}
